// 选择优惠劵活动列表label
export let selectPromotionLabels = [
  {
    label: '促销活动名称',
    value: 'promotionData.name'
  },
  {
    label: '有效期',
    value: 'validity_date'
  },
  {
    label: '活动类型',
    value: 'promotionType'
  },
  {
    label: '状态',
    value: 'promotionStatus'
  }
]
// 选择优惠活动时选择列表顶部的筛选
export let selectLisTab = [
  {
    label: '活动名称',
    type: 'input',
    clearable: true,
    value: 'searchKey' // 需返回数据的字段名
  }
]
